import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import type { State } from 'state';
import { getArticleTitle } from 'state/selectors/kb-article';
import { CsmBreadcrumbsInner, type CsmBreadcrumbsProps } from './csm-breadcrumbs-inner';

const selector = createSelector(
	(state: State, props: CsmBreadcrumbsProps) =>
		props.articleTitle ?? getArticleTitle(state, props.articleId),
	(articleTitle) => ({ articleTitle }),
);

export const CsmBreadcrumbs = connect(selector)(CsmBreadcrumbsInner);

export default CsmBreadcrumbs;
